<template>

  <div class="stages-page">
    <Header></Header>
    <section class="home-section-video">
      <!--padding:56.25% 0 0 0;-->
      <div style="padding:0 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/394955365?background=1&autoplay=1&loop=1&autopause=0&muted=1&controls=0&sidedock=0&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
    </section>
    <section class="hero-section background-fit" :style="{ backgroundImage: `url(${backgroundUrl6})` }">
      <div class="container">
        <div class="row">
          <div class="col-md-12 hero-col">

          </div>
        </div>
      </div>
    </section>
    <section class="stages-section pt-5">
      <div class="container">
        <div class="row row-1">
          <div class="col-md-4">
            <h2>Stages</h2>
          </div>
          <div class="col-md-8">
            <StageFilter />
          </div>
        </div>
      </div>
    </section>
    <section class="stg-section">
      <div class="container">
        <div class="row row-2">
          <router-link :to="`/stage/` + list._id + `/`" v-if="!loading && lists" class="col-md-6 fc-col background-fit" v-for="(list) in lists" v-bind:key="list.id" :style="{ backgroundImage: `url(${imageUrl + list.videoId[0].videoImageFile})` }">
            <div class="inner-blk">
              <div class="i-blk">
                <div class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.userId[0].profiles[0].images[0].profileImageFile})` }"></div>
                <div class="p-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <!--<router-link :to="`/stage/` + list._id + `/`"><span><img src="@/assets/img/next-arrow-white.svg" width="40" /></span></router-link>-->
                </div>
              </div>
            </div>
          </router-link>
          <a href="javascript:void(0)" data-toggle="modal" v-on:click="playVideo(imageUrl + list.videoPath, imageUrl + list.imagePath, list.youtube)" data-target="#showVideo" v-if="(list.imagePath && list.videoPath) || (list.imagePath && list.youtube)" class="col-md-6 fc-col background-fit" :style="{ backgroundImage: `url(${imageUrl + list.imagePath})` }" v-for="(list) in campaignVideos" v-bind:key="list.id">
            <div class="inner-blk">
              <div class="i-blk">
                <div class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.artistId.profiles[0].images[0].profileImageFile})` }"></div>
                <div class="p-detail">
                  <!--<router-link :to="`/campaign/` + list.campaignId._id + `/`" class="campaign-name" v-if="list.campaignId">{{list.campaignId.campaign}}</router-link>-->
                  <!--<router-link :to="`/campaign/5f0830801d84d464c6346ba8/`" class="campaign-name" v-if="!list.campaignId">6feetapart</router-link>-->
                  <span class="campaign-name" v-if="list.campaignId">{{list.campaignId.campaign}}</span>
                  <span class="campaign-name" v-if="!list.campaignId">6feetapart</span>
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <!--<span data-toggle="modal" v-on:click="playVideo(imageUrl + list.videoPath, imageUrl + list.imagePath, list.youtube)" data-target="#showVideo" style="top:25px;cursor: pointer;"><img src="@/assets/img/next-arrow-white.svg" width="40" /></span>-->
                </div>
              </div>
            </div>
          </a>
          <Loader v-if="loading" />
        </div>
      </div>
    </section>
    <div class="modal fade" id="showVideo" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding-top: 0">
            <video-player v-if="videoFlag"  class="video-player-box stg-detail-i"
                          ref="videoPlayer"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"

                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @statechanged="playerStateChanged($event)"
                          @ready="playerReadied">
            </video-player>
            <iframe style="width: 100%;height:400px;" v-if="youtubeFlag" :src="`https://www.youtube.com/embed/`+youtube" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import StageFilter from './include/StageFilter'
import Loader from './include/Loader'
import axios from 'axios'
import $ from "jquery"
import backgroundUrl from '@/assets/img/image6.jpg'
import backgroundUrl2 from '@/assets/img/image1.jpg'
import backgroundUrl1 from '@/assets/img/team/dasha.png'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
import backgroundUrl6 from '@/assets/img/videobanner.jpg'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'Stages',
  components: {
    'Header': Header,
    'Footer': Footer,
    'Loader': Loader,
    'StageFilter': StageFilter,
      videoPlayer
  },
  mounted () {
      let windowWidth = $(window).width()
      let windowHeight = windowWidth*0.5625
      if(windowWidth < 667){
          windowHeight = '100vh'
          windowWidth = '177vh'
          $('.stages-page .hero-section').height($(window).height())
      }
      $('.home-section-video iframe').css({
          height: windowHeight,
          width: windowWidth
      })
      axios
          .get('/stages')
          .then(response => {
              this.loading = false
              this.lists = response.data
          })
          .catch(error => console.log(error))
      axios
          .get('/getCampaignVideos')
          .then(response => {
              this.campaignVideos = response.data
          })
          .catch(error => console.log(error))

      var $this = this
      $('#showVideo').on('hidden.bs.modal', function () {
          if($this.youtubeFlag){
              $this.youtubeFlag = false
          } else {
              $this.videoFlag = false
          }
      })
  },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        playVideo: function (video, image, youtube){
            if(youtube && youtube.includes('youtube')){
                let uri = youtube.split('?')
                if (uri.length == 2)
                {
                    let vars = uri[1].split('&')
                    let getVars = {}
                    let tmp = ''
                    vars.forEach(function(v){
                        tmp = v.split('=')
                        if(tmp.length == 2)
                            getVars[tmp[0]] = tmp[1]
                    })
                    this.youtubeFlag = true
                    this.youtube = getVars.v
                    // do
                }
            } else {
                this.videoFlag = true
                this.playerOptions = {
                    muted: false,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        src: video
                    }],
                    poster: image
                }
            }
        },
        // listen event
        onPlayerPlay(player) {
            console.log('player play!', player)
        },
        onPlayerPause(player) {
            console.log('player pause!', player)
        },
        // ...player event

        // or listen state event
        playerStateChanged(playerCurrentState) {
            console.log('player current update state', playerCurrentState)
        },

        // player is ready
        playerReadied(player) {
            console.log('the player is readied', player)
            // you can use it to do something...
            // player.[methods]
        }
    },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl1: backgroundUrl1,
        backgroundUrl2: backgroundUrl2,
        backgroundUrl4: backgroundUrl4,
        backgroundUrl5: backgroundUrl5,
        backgroundUrl6: backgroundUrl6,
        imageUrl: process.env.imageUrl,
        loading: true,
        msg: 'Welcome to Your Vue.js App',
        lists: '',
        youtubeFlag: false,
        videoFlag: false,
        campaignVideos: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Stages.vue